import axios from 'axios'
import store from '../store'

const instance = axios.create({
  baseUrl: '/api' // This doesn't seem to be doing anything on its own
})

const token = localStorage.getItem('token')
if (token) {
  instance.defaults.headers.common['Authorization'] = token
}

instance.interceptors.request.use(config => {
  // vuetify overall spinner start
  return config
})

instance.interceptors.response.use(undefined, function (err) {
  return new Promise(function (resolve, reject) {
    if (err.response.status === 401 && err.config && !err.config.__isRetryRequest) {
      store.dispatch('userAuth/logout')
    }
    throw err;
  })
})

instance.interceptors.response.use(response => {
    // vuetify overall spinner stop
    return response;
  }, function (error) {
    // vuetify overall spinner stop
    return Promise.reject(error);
});

export default instance
